var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { Avatar, Tooltip } from '@mui/material';
import { InsertDriveFileOutlined, DescriptionOutlined, FolderZip } from '@mui/icons-material';
import { PdfPreview } from './PdfPreview';
export function FilePreviewAvatar(_a) {
    var fileName = _a.fileName, mimeType = _a.mimeType, fileUrl = _a.fileUrl;
    var commonSx = { width: 56, height: 66, border: '1px solid gray', p: 0 };
    // Imagem (png, jpeg, etc)
    if (mimeType.startsWith('data:image/')) {
        return _jsx(Avatar, { variant: "rounded", src: fileUrl, alt: fileName, sx: commonSx });
    }
    // PDF → renderiza primeira página
    if (mimeType === 'data:application/pdf;base64') {
        return (_jsx(Avatar, __assign({ variant: "rounded", sx: __assign(__assign({}, commonSx), { overflow: 'hidden' }) }, { children: _jsx(PdfPreview, { fileUrl: fileUrl }) })));
    }
    // ZIP
    if (mimeType === 'data:application/zip;base64' || mimeType === 'data:application/x-zip-compressed;base64') {
        return (_jsx(Tooltip, __assign({ title: 'O arquivo não possui visualização' }, { children: _jsx(Avatar, __assign({ variant: "rounded", sx: commonSx }, { children: _jsx(FolderZip, { sx: { color: 'yellow', width: 30, height: 30 } }) })) })));
    }
    // DOC / DOCX
    if (mimeType === 'data:application/msword;base64' ||
        mimeType === 'data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64' ||
        mimeType === 'data:application/vnd.openxmlformats-officedocument.wor;base64') {
        return (_jsx(Tooltip, __assign({ title: 'O arquivo não possui visualização' }, { children: _jsx(Avatar, __assign({ variant: "rounded", sx: commonSx }, { children: _jsx(DescriptionOutlined, { sx: { color: 'yellow', width: 30, height: 30 } }) })) })));
    }
    // Outros tipos
    return (_jsx(Avatar, __assign({ variant: "rounded", sx: commonSx }, { children: _jsx(InsertDriveFileOutlined, { sx: { width: 30, height: 30 } }) })));
}
